import type { ReactNode } from "react";
import { createElement, Fragment } from "react";

const URL_RE = /(?:https?:\/\/|www\.)[^\s<>"{}|\\^`[\]]+/gi;

function trimUrlTrailingPunctuation(raw: string): { href: string; display: string; trailing: string } {
  let display = raw;
  let trailing = "";
  while (/[.,;:!?)，。；：！？）]$/.test(display)) {
    trailing = display.slice(-1) + trailing;
    display = display.slice(0, -1);
  }
  if (display.endsWith(")") && !display.includes("(")) {
    trailing = ")" + trailing;
    display = display.slice(0, -1);
  }
  const href = display.startsWith("www.") ? `https://${display}` : display;
  return { href, display, trailing };
}

/** 将文本中的 http(s)/www 链接渲染为可点击高亮 */
export function renderTextWithLinks(
  text: string | null | undefined,
  linkClassName = "lf-text-link"
): ReactNode {
  const src = String(text ?? "");
  if (!src) return src;

  const parts: ReactNode[] = [];
  let lastIndex = 0;
  let key = 0;
  const re = new RegExp(URL_RE.source, URL_RE.flags);
  let match: RegExpExecArray | null;

  while ((match = re.exec(src)) !== null) {
    if (match.index > lastIndex) {
      parts.push(src.slice(lastIndex, match.index));
    }
    const raw = match[0];
    const { href, display, trailing } = trimUrlTrailingPunctuation(raw);
    parts.push(
      createElement(
        "a",
        {
          key: `link-${key++}`,
          href,
          className: linkClassName,
          target: "_blank",
          rel: "noopener noreferrer",
        },
        display
      )
    );
    if (trailing) {
      parts.push(trailing);
    }
    lastIndex = match.index + raw.length;
  }

  if (lastIndex < src.length) {
    parts.push(src.slice(lastIndex));
  }

  return parts.length > 0 ? createElement(Fragment, null, ...parts) : src;
}
